import { Children } from 'react';

function NavigationLinkList({ children, title, 'data-track-container': dataTrackContainer }: { children: React.ReactNode; title: string; 'data-track-container'?: string }) {
  return (
    <div data-track-container={dataTrackContainer}>
      <p className="paragraph-s mb-4 text-foreground-subtle">{title}</p>
      <ul className="list-none text-foreground">
        {Children.map(children, child => (
          <li className="link-label-s not-last:mb-4">{child}</li>
        ))}
      </ul>
    </div>
  );
}

export { NavigationLinkList };
